export const PlacesErrorCode = {
  PlaceNotFound: 'PlaceNotFound',
  NotPlaceOwner: 'NotPlaceOwner',
  NotPlaceMember: 'NotPlaceMember',
  NotAFriend: 'NotAFriend',
  AlreadyMember: 'AlreadyMember',
  InviteInvalid: 'InviteInvalid',
  InviteExpired: 'InviteExpired',
  InviteRevoked: 'InviteRevoked',
  InviteExhausted: 'InviteExhausted',
  PlaceTypeMismatch: 'PlaceTypeMismatch',
  CircleNotFound: 'CircleNotFound',
} as const
export type PlacesErrorCode = (typeof PlacesErrorCode)[keyof typeof PlacesErrorCode]

export const PresenceErrorCode = {
  PlaceNotFound: 'PlaceNotFound',
  BroadcastNotConsented: 'BroadcastNotConsented',
  OutOfRange: 'OutOfRange',
  MinorNotPublic: 'MinorNotPublic',
  GhostMode: 'GhostMode',
  HiddenAtEvent: 'HiddenAtEvent',
  LocationRequired: 'LocationRequired',
  LeftLiveRoom: 'LeftLiveRoom',
} as const
export type PresenceErrorCode = (typeof PresenceErrorCode)[keyof typeof PresenceErrorCode]

export const LiveRoomErrorCode = {
  EventNotFound: 'LiveRoomEventNotFound',
  NotOpenYet: 'LiveRoomNotOpen',
  InvalidCheckinCode: 'InvalidCheckinCode',
  AccuracyTooLow: 'LocationAccuracyTooLow',
  NotCheckedIn: 'LiveRoomNotCheckedIn',
  NotOpenVisible: 'LiveRoomNotOpenVisible',
  WaveNotPossible: 'LiveRoomWaveNotPossible',
  Disabled: 'LiveRoomDisabled',
  OpenNotOffered: 'LiveRoomOpenNotOffered',
  GuestNeedsCode: 'LiveRoomGuestNeedsCode',
  MomentsNeedAccount: 'LiveRoomMomentsNeedAccount',
  Removed: 'LiveRoomRemoved',
  WaveLimit: 'LiveRoomWaveLimit',
  HiNotAccepted: 'LiveRoomHiNotAccepted',
  GroupFull: 'LiveRoomGroupFull',
  NotInGroup: 'LiveRoomNotInGroup',
  GroupAddNotAllowed: 'LiveRoomGroupAddNotAllowed',
  GroupInviteGone: 'LiveRoomGroupInviteGone',
  UserRoomRunning: 'LiveRoomUserRoomRunning',
  UserRoomNeedsAccount: 'LiveRoomUserRoomNeedsAccount',
  PublicNeedsAge: 'LiveRoomPublicNeedsAge',
  NotRoomOwner: 'LiveRoomNotOwner',
  VisibilityOnlyWiden: 'LiveRoomVisibilityOnlyWiden',
  ExtendLimit: 'LiveRoomExtendLimit',
  Closed: 'LiveRoomClosed',
  LocationNotAllowed: 'LiveRoomLocationNotAllowed',
  CannotRemoveOwner: 'LiveRoomCannotRemoveOwner',
  RequestRequired: 'LiveRoomRequestRequired',
  RequestNotNeeded: 'LiveRoomRequestNotNeeded',
  RequestNeedsAccount: 'LiveRoomRequestNeedsAccount',
  RequestNotFound: 'LiveRoomRequestNotFound',
  TooManyCompanions: 'LiveRoomTooManyCompanions',
  NoPlacesLeft: 'LiveRoomNoPlacesLeft',
  NotHost: 'LiveRoomNotHost',
  AnnouncementTooSoon: 'LiveRoomAnnouncementTooSoon',
  AnnouncementLimit: 'LiveRoomAnnouncementLimit',
  NoVenueRoom: 'LiveRoomNoVenueRoom',
  ShotsUsedUp: 'LiveRoomShotsUsedUp',
  MomentLocked: 'LiveRoomMomentLocked',
  MembersOnly: 'LiveRoomMembersOnly',
  LinkCodeInvalid: 'OrganizerLinkCodeInvalid',
  LinkNotFound: 'OrganizerLinkNotFound',
} as const
export type LiveRoomErrorCode = (typeof LiveRoomErrorCode)[keyof typeof LiveRoomErrorCode]
